export const currentUserId: string = window.location.search.slice(1);
